module.exports = __webpack_public_path__ + "static/media/dj.9c11d841.jpg";